import { useCallback, useRef, useState } from "react";

export default function useForm() {
  const fieldsRef = useRef({});
  const validationsRef = useRef({});
  const [errors, setErrors] = useState({});

  const handleOnChange = useCallback((event) => {
    const fields = fieldsRef.current;
    const name = event.target.name;
    const value = event.target.value;

    fields[name] = value;
    setErrors({});
  }, []);

  const validateFields = useCallback(() => {
    const fields = fieldsRef.current;
    const validations = validationsRef.current;
    let currentErrors = {};

    for (const key in validations) {
      const validation = validations[key];

      if (validation.required && !fields[key]) {
        if (currentErrors[key] === undefined) {
          currentErrors[key] = {
            message: 'This field is required.'
          };
        };
      };

      if (validation.pattern) {

        if (!fields[key] || !validation.pattern.test(fields[key]?.toLowerCase())) {
          if (currentErrors[key] === undefined) {
            currentErrors[key] = {
              message: 'Invalid email address provided.'
            };
          };
        }
      };
    };

    const isError = Object.keys(currentErrors).length !== 0;

    return {
      isError,
      currentErrors
    };
  }, []);

  const register = useCallback((name, options = {}) => {
    let fields = fieldsRef.current;
    let validations = validationsRef.current;

    if (fields[name] === undefined) {
      fields[name] = null;
      validations[name] = options;
    };

    return {
      name: name,
      onChange: handleOnChange
    };
  }, [handleOnChange]);

  const submit = useCallback((onSubmit) => {
    return (event) => {
      event.preventDefault();

      const { isError, currentErrors } = validateFields();
      setErrors(currentErrors);

      if (!isError) {
        onSubmit(fieldsRef.current);
      };
    };
  }, [validateFields]);

  return {
    register: register,
    submit: submit,
    errors: errors
  };
};